import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=553a9afc&"
import script from "./HeaderSearch.vue?vue&type=script&lang=ts&"
export * from "./HeaderSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports